import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, vModelText as _vModelText, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27eca9ad"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = { class: "ss-principais-acoes" }
const _hoisted_5 = { class: "ant-btn-group ss-grupo-recursos" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Gerar", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "ss-tela-conteudo" }
const _hoisted_9 = { class: "ss-card ss-card-space" }
const _hoisted_10 = { class: "ant-row" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-24 ant-col-xl-3" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "ss-selecionar-empresas" }, "EMPRESAS")
], -1))
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_13 = { class: "ant-row" }
const _hoisted_14 = { class: "ant-col ant-col-xs-12 ant-col-xl-6" }
const _hoisted_15 = { class: "ant-col ant-col-xs-12 ant-col-xl-6" }
const _hoisted_16 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_17 = { class: "ant-row" }
const _hoisted_18 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_19 = { class: "ant-row" }
const _hoisted_20 = { class: "ant-col ant-col-xs-5 ant-col-xl-5" }
const _hoisted_21 = { class: "ant-col ant-col-xs-5 ant-col-xl-5" }
const _hoisted_22 = { class: "ant-col ant-col-xs-5 ant-col-xl-5" }
const _hoisted_23 = {
  key: 0,
  class: "ss-card ss-card-space ss-alinhar-texto-esquerda",
  style: {"min-height":"40%"}
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "ss-table-apresentacao-mobile" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Data: ", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Número: ", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Categoria: ", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Crédito: ", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Débito: ", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Saldo: ", -1))
const _hoisted_33 = { key: 2 }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { class: "ss-table-apresentacao-mobile" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Data: ", -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Número: ", -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Categoria: ", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Crédito: ", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Débito: ", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Saldo: ", -1))
const _hoisted_44 = { key: 2 }
const _hoisted_45 = { class: "ant-row" }
const _hoisted_46 = { class: "ant-col ant-col-xs-24 ant-col-xl-21" }
const _hoisted_47 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_48 = {
  class: "ant-input-affix-wrapper ss-paginacao-qtde-registros",
  style: {"margin-top":"0px"}
}
const _hoisted_49 = { class: "ant-input-suffix" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Limite total de registros. Lembre-se: Quanto menor a quantidade de registros mais rápido o seu resultado será apresentado.", -1))
const _hoisted_51 = {
  tabindex: "-1",
  role: "img",
  "aria-label": "info-circle",
  class: "anticon anticon-info-circle",
  style: {"color":"rgba(0, 0, 0, 0.45)"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_titulo_padrao = _resolveComponent("titulo-padrao")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_collapse_panel = _resolveComponent("a-collapse-panel")!
  const _component_a_collapse = _resolveComponent("a-collapse")!
  const _component_selecionar_tipo_relatorio_balancete = _resolveComponent("selecionar-tipo-relatorio-balancete")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_data_inicial_final = _resolveComponent("selecionar-data-inicial-final")!
  const _component_selecionar_categoria_plano_conta = _resolveComponent("selecionar-categoria-plano-conta")!
  const _component_selecionar_conta = _resolveComponent("selecionar-conta")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_totalizador_decorado = _resolveComponent("totalizador-decorado")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_card = _resolveComponent("card")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_titulo_padrao, {
            identificadorRecurso: _ctx.telaBase.identificadorRecurso,
            tituloRecurso: _ctx.telaBase.titulo,
            exibirAtalhosTela: true,
            exibirHistoricoTela: false,
            empresasSelecionadas: [_ctx.state.filtros.empresa]
          }, {
            BotoesAcoes: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("button", {
                    class: "ant-btn ant-btn-secondary ss-btn-recursos",
                    title: "Imprimir",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.PDF)))
                  }, [
                    _createVNode(_component_icone, { nome: "imprimir" })
                  ]),
                  _createElementVNode("button", {
                    class: "ant-btn ant-btn-secondary ss-btn-recursos",
                    title: "Exportar Word",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.Word)))
                  }, [
                    _createVNode(_component_icone, { nome: "word" })
                  ]),
                  _createElementVNode("button", {
                    class: "ant-btn ant-btn-secondary ss-btn-recursos",
                    title: "Exportar Excel",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.Excel)))
                  }, [
                    _createVNode(_component_icone, { nome: "excel" })
                  ]),
                  _createElementVNode("button", {
                    class: "ant-btn ant-btn-secondary ss-btn-recursos",
                    title: "Exportar CSV",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.imprimir(_ctx.ETipoArquivo.CSV)))
                  }, [
                    _createVNode(_component_icone, { nome: "download-arquivo" })
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "ant-btn ant-btn-primary ss-btn-tela",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.buscarRelatorio && _ctx.buscarRelatorio(...args)))
                  }, _hoisted_7)
                ])
              ])
            ]),
            _: 1
          }, 8, ["identificadorRecurso", "tituloRecurso", "empresasSelecionadas"]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _withDirectives(_createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_a_select, {
                    value: _ctx.state.filtros.empresa,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.filtros.empresa) = $event)),
                    options: _ctx.telaBase.empresasDisponiveis,
                    style: {"width":"100%"},
                    optionFilterProp: "label",
                    onChange: _ctx.atualizarSelecaoEmpresas
                  }, null, 8, ["value", "options", "onChange"])
                ])
              ], 512), [
                [_vShow, _ctx.telaBase.apresentarEmpresas]
              ]),
              _createVNode(_component_a_collapse, {
                ghost: "",
                class: "ss-accordion",
                activeKey: _ctx.state.mostrarFiltrosInteligentes,
                "onUpdate:activeKey": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.mostrarFiltrosInteligentes) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_collapse_panel, {
                    key: "1",
                    header: "FILTROS INTELIGENTES"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("button", {
                        class: "ant-btn ss-btn-filtro-inteligente",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.usarFiltroInteligente(1)))
                      }, "Balancete geral do mês atual"),
                      _createElementVNode("button", {
                        class: "ant-btn ss-btn-filtro-inteligente",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.usarFiltroInteligente(2)))
                      }, "Balancete diário do mês atual"),
                      _createElementVNode("button", {
                        class: "ant-btn ss-btn-filtro-inteligente",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.usarFiltroInteligente(3)))
                      }, "Balancete geral do próximo mês"),
                      _createElementVNode("button", {
                        class: "ant-btn ss-btn-filtro-inteligente",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.usarFiltroInteligente(4)))
                      }, "Balancete diário do próximo ês")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["activeKey"]),
              _createVNode(_component_a_collapse, {
                ghost: "",
                class: "ss-accordion",
                activeKey: _ctx.state.mostrarFiltros,
                "onUpdate:activeKey": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.mostrarFiltros) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_collapse_panel, {
                    key: "1",
                    header: "FILTROS PERSONALIZADOS"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form, { layout: "vertical" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _createVNode(_component_a_form_item, {
                                label: "Variação",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_tipo_relatorio_balancete, {
                                    valor: _ctx.state.filtros.tipo,
                                    "onUpdate:valor": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.filtros.tipo) = $event))
                                  }, null, 8, ["valor"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                              _createVNode(_component_a_form_item, {
                                label: "Período",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_data_inicial_final, {
                                    dataInicialSelecionada: _ctx.state.dataInicial,
                                    "onUpdate:dataInicialSelecionada": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.dataInicial) = $event)),
                                    dataFinalSelecionada: _ctx.state.dataFinal,
                                    "onUpdate:dataFinalSelecionada": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.dataFinal) = $event))
                                  }, null, 8, ["dataInicialSelecionada", "dataFinalSelecionada"])
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_16, [
                              _createVNode(_component_a_form_item, {
                                label: "Categorias",
                                class: "ss-margin-campos"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_selecionar_categoria_plano_conta, {
                                    varios: true,
                                    empresas: [_ctx.state.filtros.empresa],
                                    "codigos-selecionados": _ctx.state.filtros.categorias,
                                    "onUpdate:codigosSelecionados": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.filtros.categorias) = $event))
                                  }, null, 8, ["empresas", "codigos-selecionados"])
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                              _createVNode(_component_selecionar_conta, {
                                varios: true,
                                empresas: [_ctx.state.filtros.empresa],
                                codigosSelecionados: _ctx.state.filtros.contas,
                                "onUpdate:codigosSelecionados": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.filtros.contas) = $event))
                              }, null, 8, ["empresas", "codigosSelecionados"])
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["activeKey"]),
              (_ctx.state.itens.length > 0)
                ? (_openBlock(), _createBlock(_component_a_collapse, {
                    key: 0,
                    ghost: "",
                    class: "ss-accordion",
                    activeKey: _ctx.state.mostrarTotalizadores,
                    "onUpdate:activeKey": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.mostrarTotalizadores) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_collapse_panel, {
                        key: "1",
                        header: "TOTALIZADORES"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                              _createVNode(_component_totalizador_decorado, {
                                titulo: "TOTAL DE CRÉDITOS",
                                cor: "#424BC6",
                                iconeColorido: true,
                                monetario: true,
                                valor: _ctx.state.resultado.totalCreditos
                              }, null, 8, ["valor"])
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                              _createVNode(_component_totalizador_decorado, {
                                titulo: "TOTAL DE DÉBITOS",
                                cor: "#F7E811",
                                iconeColorido: true,
                                monetario: true,
                                valor: _ctx.state.resultado.totalDebitos
                              }, null, 8, ["valor"])
                            ]),
                            _createElementVNode("div", _hoisted_22, [
                              _createVNode(_component_totalizador_decorado, {
                                titulo: "SALDO TOTAL",
                                cor: "#8DC642",
                                iconeColorido: true,
                                monetario: true,
                                valor: _ctx.state.resultado.saldoTotal
                              }, null, 8, ["valor"])
                            ])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["activeKey"]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.state.mostrarTitulos)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createVNode(_component_card, { titulo: "RESULTADO" }, {
                    default: _withCtx(() => [
                      (_ctx.state.filtros.tipo === _ctx.ETipoRelatorioBalancete.Detalhado)
                        ? (_openBlock(), _createBlock(_component_a_table, {
                            key: 0,
                            style: {"margin-bottom":"5px"},
                            columns: _ctx.gradeBase.colunas.filter(item => item.visible),
                            "data-source": _ctx.state.grupos,
                            rowKey: "numeroCategoria",
                            pagination: false,
                            loading: _ctx.telaBase.carregando,
                            scroll: _ctx.gradeBase.layoutMobile?null: { y: _ctx.window.innerHeight - 345 },
                            size: "small"
                          }, {
                            bodyCell: _withCtx(({ column, record, text }) => [
                              (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text, 2, true, true)), 1))
                                : (column.key === 'Item')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode("\" "),
                                      _createElementVNode("div", _hoisted_25, [
                                        (_ctx.state.filtrosUtilizados.tipo == _ctx.ETipoRelatorioBalancete.Diario)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                                              _hoisted_27,
                                              _createTextVNode(_toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.data)), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("span", null, [
                                          _hoisted_28,
                                          _createTextVNode(_toDisplayString(record.numeroCategoria), 1)
                                        ]),
                                        _createElementVNode("span", null, [
                                          _hoisted_29,
                                          _createTextVNode(_toDisplayString(record.nomeCategoria), 1)
                                        ]),
                                        _createElementVNode("span", null, [
                                          _hoisted_30,
                                          _createTextVNode(_toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.credito,2, true)), 1)
                                        ]),
                                        _createElementVNode("span", null, [
                                          _hoisted_31,
                                          _createTextVNode(_toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.debito,2, true)), 1)
                                        ]),
                                        _createElementVNode("span", null, [
                                          _hoisted_32,
                                          _createTextVNode(_toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.saldo,2, true, true)), 1)
                                        ])
                                      ])
                                    ], 64))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(text), 1))
                            ]),
                            expandedRowRender: _withCtx(({ record }) => [
                              _createVNode(_component_a_table, {
                                columns: _ctx.state.colunasInternas,
                                "data-source": record.itens,
                                pagination: false
                              }, {
                                bodyCell: _withCtx(({ column, text }) => [
                                  (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text, 2, true, true)), 1))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(_toDisplayString(text), 1)
                                      ], 64))
                                ]),
                                _: 2
                              }, 1032, ["columns", "data-source"])
                            ]),
                            emptyText: _withCtx(() => [
                              _createVNode(_component_mensagem_sem_dados, {
                                resultadoPesquisa: !_ctx.telaBase.carregando,
                                mensagem: _ctx.telaBase.carregando?'Buscando informações, por favor aguarde...':'Nenhum registro foi encontrado com estes filtros!'
                              }, null, 8, ["resultadoPesquisa", "mensagem"])
                            ]),
                            _: 1
                          }, 8, ["columns", "data-source", "loading", "scroll"]))
                        : (_openBlock(), _createBlock(_component_a_table, {
                            key: 1,
                            style: {"margin-bottom":"5px"},
                            columns: _ctx.gradeBase.colunas.filter(item => item.visible),
                            "data-source": _ctx.state.itens,
                            rowKey: "codigo",
                            pagination: false,
                            loading: _ctx.telaBase.carregando,
                            scroll: _ctx.gradeBase.layoutMobile?null: { y: _ctx.window.innerHeight - 345 },
                            size: "small"
                          }, {
                            bodyCell: _withCtx(({ column, record, text }) => [
                              (column.customRenderRow === _ctx.ECustomRenderRow.MascararFracionado)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text, 2, true, true)), 1))
                                : (column.key === 'Item')
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode("\" "),
                                      _createElementVNode("div", _hoisted_36, [
                                        (_ctx.state.filtrosUtilizados.tipo == _ctx.ETipoRelatorioBalancete.Diario)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_37, [
                                              _hoisted_38,
                                              _createTextVNode(_toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(record.data)), 1)
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createElementVNode("span", null, [
                                          _hoisted_39,
                                          _createTextVNode(_toDisplayString(record.numeroCategoria), 1)
                                        ]),
                                        _createElementVNode("span", null, [
                                          _hoisted_40,
                                          _createTextVNode(_toDisplayString(record.nomeCategoria), 1)
                                        ]),
                                        _createElementVNode("span", null, [
                                          _hoisted_41,
                                          _createTextVNode(_toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.credito,2, true)), 1)
                                        ]),
                                        _createElementVNode("span", null, [
                                          _hoisted_42,
                                          _createTextVNode(_toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.debito,2, true)), 1)
                                        ]),
                                        _createElementVNode("span", null, [
                                          _hoisted_43,
                                          _createTextVNode(_toDisplayString(_ctx.UtilitarioMascara.mascararValor(record.saldo,2, true, true)), 1)
                                        ])
                                      ])
                                    ], 64))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(text), 1))
                            ]),
                            emptyText: _withCtx(() => [
                              _createVNode(_component_mensagem_sem_dados, {
                                resultadoPesquisa: !_ctx.telaBase.carregando,
                                mensagem: _ctx.telaBase.carregando?'Buscando informações, por favor aguarde...':'Nenhum registro foi encontrado com estes filtros!'
                              }, null, 8, ["resultadoPesquisa", "mensagem"])
                            ]),
                            _: 1
                          }, 8, ["columns", "data-source", "loading", "scroll"])),
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                          _createVNode(_component_a_pagination, {
                            class: "ss-paginacao-completa",
                            current: _ctx.state.paginacao.current,
                            "onUpdate:current": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.paginacao.current) = $event)),
                            size: "small",
                            total: _ctx.state.paginacaoApi.totalRegistros,
                            "show-total": (total, range) => `${_ctx.UtilitarioMascara.mascararNumeroInteiro(range[0])} - ${_ctx.UtilitarioMascara.mascararNumeroInteiro(range[1])} de ${_ctx.UtilitarioMascara.mascararNumeroInteiro(total)} registros`,
                            "page-size": _ctx.state.paginacao.pageSize,
                            pageSizeOptions: _ctx.state.paginacao.pageSizeOptions,
                            onShowSizeChange: _ctx.onShowSizeChange,
                            showSizeChanger: _ctx.state.paginacao.showSizeChanger,
                            onChange: _ctx.onPageChange
                          }, null, 8, ["current", "total", "show-total", "page-size", "pageSizeOptions", "onShowSizeChange", "showSizeChanger", "onChange"])
                        ]),
                        _createElementVNode("div", _hoisted_47, [
                          _createElementVNode("span", _hoisted_48, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.totalRegistrosComMascara) = $event)),
                              onKeyup: _cache[20] || (_cache[20] = ($event: any) => (_ctx.alterarQuantidadeRegistroTotal(($event.target as HTMLInputElement).value))),
                              placeholder: "Total registros",
                              type: "text",
                              class: "ant-input hidden"
                            }, null, 544), [
                              [_vModelText, _ctx.state.totalRegistrosComMascara],
                              [_directive_maska, _ctx.UtilitarioMascara.formatoMascaraNumeroInteiro]
                            ]),
                            _createElementVNode("span", _hoisted_49, [
                              _createVNode(_component_a_tooltip, { placement: "top" }, {
                                title: _withCtx(() => [
                                  _hoisted_50
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("span", _hoisted_51, [
                                    _createVNode(_component_icone, { nome: "informacoes" })
                                  ])
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createVNode(_component_preview_pdf, {
      arquivos: _ctx.state.arquivosPdf
    }, null, 8, ["arquivos"])
  ], 64))
}